
import pkg from './package.json';

const components = require('./components');

components.cruiVersion = pkg.version;
components.Accordion = components.CNAccordion;

module.exports = components;



// WEBPACK FOOTER //
// ./index.js